/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import {
  CContainer, CRow, CCol, CCard, CCardBody, CCardHeader,
  CBreadcrumb, CBreadcrumbItem
} from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { createWeaveColorRequestAction } from '../../store/weavecolor/weaveColorActions';
import WeaveColorInputs from '../../components/WeaveColorInputs/WeaveColorInputs';
import {
  getWeaves, getThreads, getYarns, getColors
} from '../../services/endpoints';

const CreateWeaveColor = ({ createWeaveColorRequest, isLoading, createWeaveColorData }) => {
  const navigate = useNavigate();
  const [dropdowns, setDropdowns] = useState({
    weaveList: [],
    threadList: [],
    yarnList: [],
    colorList: [],
  });

  useEffect(() => {
    const fetchDropdowns = async () => {
      const sessionUserId = localStorage.getItem('sessionUserId');
      const payload = { SessionUserId: sessionUserId };
      const [weaveRes, threadRes, yarnRes, colorRes] = await Promise.all([
        getWeaves(payload),
        getThreads(payload),
        getYarns(payload),
        getColors(payload),
      ]);
      setDropdowns({
        weaveList: weaveRes.data?.WeaveList || [],
        threadList: threadRes.data?.ThreadList || [],
        yarnList: yarnRes.data?.YarnList || [],
        colorList: colorRes.data?.ColorList || [],
      });
    };

    fetchDropdowns();
  }, []);

  const handleSubmit = (data) => {
    createWeaveColorRequest({ data, navigate });
  };

  const handleCancel = () => {
    navigate('/weavecolor');
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/weavecolor" onClick={(e) => { e.preventDefault(); handleCancel(); }}>
          WeaveColor
        </CBreadcrumbItem>
        <CBreadcrumbItem active>Create</CBreadcrumbItem>
      </CBreadcrumb>

      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader><h4>Create Weave Color</h4></CCardHeader>
            <CCardBody>
              <WeaveColorInputs
                onSubmit={handleSubmit}
                onCancel={handleCancel}
                isLoading={isLoading}
                submitResponse={createWeaveColorData}
                {...dropdowns}
              />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state.loadingReducer.isLoading,
  createWeaveColorData: state.weaveColorReducer.createWeaveColorData,
});

const mapDispatchToProps = {
  createWeaveColorRequest: createWeaveColorRequestAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateWeaveColor);
